export default __webpack_public_path__ + "static/media/delete_white.1e871a98.svg";